import React from 'react'

const FollowIcon = ({
    icon
}) => {
  return (
      <i className={`fa ${icon} w3-hover-opacity`} />
  )
}

export default FollowIcon